import axios from 'axios';
import Vue from 'vue'

export default {
    getTotalTurnover(month,year,isMonthly,isYearly){
        return axios.get('/api/reporting/turnover', { params: { month: month, year:year, isMonthly:isMonthly,isYearly:isYearly } } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findProductTypeChart(customerCategory, start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/productType/chart/list', { params: { customerCategory: customerCategory , start: start, end: end, countryId: countryId, cityId: cityId, customerId: customerId } } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPurchasesByBrand(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalSalesByBrand',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getQuantityByBrand(start,end,countryId,cityId,customerId, customerCategory, allstatus){
        return axios.get('/api/reporting/totalQuantitiesByBrand',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId, customerCategory:customerCategory,allstatus:allstatus} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTopTenItems(page, pageSize,start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/topItems',{params: {page: page, pageSize: pageSize,start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTotalSales(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalSales',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersStatus(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/ordersStatus',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getInvoicesStatus(countryId,cityId,customerId){
        return axios.get('/api/reporting/invoicesStatus',{params: {countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSearchHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/searchHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAccessHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/accessHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSyncHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/syncHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getLastSynchronisationAccess(){
        return axios.get('/api/reporting/lastSynchronisationAccess')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}